import ImageIcon from './ImageIcon';
import styles from './Placeholder.module.scss';

export default function Placeholder() {
  return (
    <div className={styles.placeholder}>
      <div className={styles.message}>Tack för att du reser tillsammans.</div>
      <ImageIcon className={styles.logo} type="logo" alt="Västtrafik" />
    </div>
  );
}
